export const formatCurrency = (value, configCurrency) => {
  let config = {
    style: configCurrency?.style || "currency",
    currency: configCurrency?.currency || "BRL",
    locale: configCurrency?.locale || "pt-BR",
    precision: configCurrency?.precision || 2
  };

  if (!value) {
    value = 0;
  }

  var options = {
    style: config.style,
    currency: config.currency
  };

  if (typeof config.precision === "number") {
    options.minimumFractionDigits = config.precision;
    options.maximumFractionDigits = config.precision;
  }

  if (typeof value === "string") {
    value = parseFloat(value);
  }

  return value.toLocaleString(config.locale, options);
};

export const formatCurrencyBRL = value => {
  return formatCurrency(value, {
    style: "currency",
    currency: "BRL",
    locale: "pt-BR",
    precision: 2
  });
};

export const getBRLValueWithoutDecimals = value => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const formatCurrencyBD = (value, precision = 2) => {
  return parseFloat(
    value
      .toString()
      .replace(".", "")
      .replace(",", ".")
  ).toFixed(precision);
};

export const formatPrecisionCurrency = (value, precision = 2) => {
  return parseFloat(value).toFixed(precision);
};

export const getCurrencyValueIfNotEmpty = value => {
  return value != null && !isNaN(value) && parseFloat(value) > 0
    ? formatCurrency(value)
    : "";
};

export const getCurrencyValueIfNotEmptyWithNegativeNumbers = value => {
  return value != null && !isNaN(value) ? formatCurrency(value) : "";
};
